import React from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import i18n, { getUserLangKey } from '../i18n';

const SUPPORTED_LANGUAGES = [
  { code: 'en', labelKey: 'languageSwitcher.en' },
  { code: 'af', labelKey: 'languageSwitcher.af' },
];

/**
 * LanguageSwitcher
 *
 * Renders a select control that allows the user to switch between supported
 * interface languages. The selection is persisted to localStorage under a
 * per-user key so each user's preference is independent.
 */
const LanguageSwitcher: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useAuth();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const lang = e.target.value;
    if (user) {
      localStorage.setItem(getUserLangKey(user.id), lang);
    }
    i18n.changeLanguage(lang);
  };

  return (
    <Form.Group controlId="languageSwitcher" className="mb-3">
      <Form.Label className="fw-semibold">{t('languageSwitcher.label')}</Form.Label>
      <Form.Select value={i18n.language} onChange={handleChange} style={{ maxWidth: '300px' }}>
        {SUPPORTED_LANGUAGES.map(({ code, labelKey }) => (
          <option key={code} value={code}>
            {t(labelKey)}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
};

export default LanguageSwitcher;
